module.exports = __webpack_public_path__ + "static/media/1.771a7e14.mp4";